export default "__VITE_ASSET__BThQX_ko__"